module.exports = __webpack_public_path__ + "img/9.0f3daff9.png";